import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=648acc8a&scoped=true&"
import script from "./CompanyCard.vue?vue&type=script&lang=js&"
export * from "./CompanyCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=648acc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648acc8a",
  null
  
)

export default component.exports